export default {
  computed: {
    dark () {
      return this.$vuetify.theme.dark
    }
  }
}
